import api from "./api";

export interface WatchlistService {
  toggleWatchlist: (tradingsymbol: string) => Promise<{ success: boolean; isWatchlisted: boolean }>;
  getWatchlist: () => Promise<any[]>;
}

export const watchlistService: WatchlistService = {
  toggleWatchlist: async (tradingsymbol: string) => {
    const response = await api.post("/watchlist/toggle", { tradingsymbol });
    return response.data;
  },
  getWatchlist: async () => {
    try {
        const response = await api.get("/watchlist");
        return response.data;
    } catch (error) {
        console.error("Error fetching watchlist:", error);
        throw error;
    }
  }
};
